// 引入ali-oss
let OSS = require('ali-oss')


export default new OSS({
  accessKeyId: 'LTAI5tQGJew9ampWXRLbgnfB',
  accessKeySecret: '8jkY0iBH2w5k2UEOPOC0OqmxOhtN0D',
  bucket: 'oss-mp-casio-music',
  endpoint: 'https://oss-cn-beijing.aliyuncs.com',
  timeout:6000000
})




